import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Table from '@material-ui/core/Table';
import GroupGochiMenuTableHead from '../../components/molecules/GroupGochiMenuTableHead';
import GroupGochiMenuTableBody from '../../components/molecules/GroupGochiMenuTableBody';
// import TablePagination from '../../components/molecules/TablePagination';
import ExPagination from '../../components/molecules/ExPagination';
import GroupGochiMenuDetail from './GroupGochiMenuDetail';
import GroupGochiMenuEdit from './GroupGochiMenuEdit';
import DeleteDialog from '../../components/molecules/DeleteDialog';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import {
  getGroupGochiMenus,
  getGroupGochiMenuDetail,
  deleteGroupGochiMenu
} from '../../actions/GroupGochiMenus';
import { sendLogin } from '../../auth/Auth';

const styles = {
  scrollTable: {
    maxHeight: 375,
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      groupMenus: state.groupGochiMenus.groupMenus,
      totalCount: state.groupGochiMenus.totalCount,
      offset: state.groupGochiMenus.offset
    }),
    dispatch => ({
      actions: bindActionCreators(
        { getGroupGochiMenus, getGroupGochiMenuDetail, deleteGroupGochiMenu },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDetailModal', 'updateOpenDetailModal', false),
  withState('openEdit', 'updateOpenEdit', false),
  withState('openEditConfirm', 'updateOpenEditConfirm', false),
  withState('openEditModal', 'updateOpenEditModal', false),
  withState('openDelete', 'updateOpenDelete', false),
  withState('openDeleteProgress', 'updateOpenDeleteProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isDeleteSuccess', 'updateIsDeleteSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('groupId', 'setGroupId', 0),
  withState('groupName', 'setGroupName', ''),
  withState('menuId', 'setMenuId', 0),
  withState('menuName', 'setMenuName', ''),
  withState('price', 'setPrice', ''),
  withState('priceCalc', 'setPriceCalc', '0 (税抜 0)'),
  withState('description', 'setDescription', ''),
  withState('taxType', 'setTaxType', 'EXTERNAL'),
  withState('taxTypeStr', 'setTaxTypeStr', '外税'),
  withState('reducedTaxCheck', 'setReducedTaxCheck', false),
  withState('reducedTaxType', 'setReducedTaxType', 'UNREDUCED'),
  withState('reducedTaxTypeStr', 'setReducedTaxTypeStr', '対象外'),
  withState('tagStr', 'setTagStr', ''),
  withState('tags', 'setTags', null),
  withState('image', 'setImage', null),
  withState('previewImage', 'setPreviewImage', null),
  withState('updatedAt', 'setUpdatedAt', ''),
  withState('createdAt', 'setCreatedAt', ''),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('targetRowId', 'setTargetRowId', 0),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', 'menuId'),
  withState('page', 'setPage', 0),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangeRowsPerPage: props => (event, rowsPerPage) => {
      props.setRowsPerPage(rowsPerPage);
    },
    handleRequestSort: props => property => {
      const isDesc = props.orderBy === property && props.order === 'desc';
      props.setOrder(isDesc ? 'asc' : 'desc');
      props.setOrderBy(property);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    roles,
    progress,
    searchKey,
    page,
    selectedPage,
    totalCount,
    offset,
    handleChangePage,
    groupMenus,
    name,
    openDetailModal,
    updateOpenDetailModal,
    openDelete,
    updateOpenDelete,
    rowsPerPage,
    targetRowId,
    setTargetRowId,
    openEdit,
    updateOpenEdit,
    openEditConfirm,
    updateOpenEditConfirm,
    openDeleteProgress,
    updateOpenDeleteProgress,
    loading,
    updateLoading,
    isDeleteSuccess,
    updateIsDeleteSuccess,
    resultMessage,
    setResultMessage,
    groupId,
    setGroupId,
    groupName,
    setGroupName,
    menuId,
    setMenuId,
    menuName,
    setMenuName,
    price,
    setPrice,
    description,
    setDescription,
    taxType,
    setTaxType,
    taxTypeStr,
    setTaxTypeStr,
    reducedTaxType,
    setReducedTaxType,
    reducedTaxCheck,
    setReducedTaxCheck,
    reducedTaxTypeStr,
    setReducedTaxTypeStr,
    tags,
    setTags,
    tagStr,
    setTagStr,
    image,
    setImage,
    createdAt,
    setCreatedAt,
    updatedAt,
    setUpdatedAt,
    order,
    orderBy,
    handleChangeRowsPerPage,
    handleRequestSort
  }) => {
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, totalCount - page * rowsPerPage);
    const detail = {
      groupId,
      groupName,
      menuId,
      menuName,
      price,
      description,
      taxType,
      taxTypeStr,
      reducedTaxType,
      reducedTaxCheck,
      reducedTaxTypeStr,
      tags,
      tagStr,
      image,
      createdAt,
      updatedAt
    };
    const getGroupGochiMenu = async id => {
      await actions.getGroupGochiMenuDetail(id).then(detailData => {
        checkSession(detailData);
        setGroupId(detailData.payload.groupId);
        setGroupName(detailData.payload.groupName);
        setMenuId(detailData.payload.menuId);
        setMenuName(detailData.payload.menuName);
        setPrice(detailData.payload.price);
        setDescription(detailData.payload.description);
        setTaxType(detailData.payload.taxType);
        setTaxTypeStr(detailData.payload.taxTypeStr);
        setReducedTaxType(detailData.payload.reducedTaxType);
        if (detailData.payload.reducedTaxType === 'REDUCED') {
          setReducedTaxCheck(true);
          setReducedTaxTypeStr('対象');
        } else {
          setReducedTaxCheck(false);
          setReducedTaxTypeStr('対象外');
        }
        setTags(detailData.payload.tags);
        setTagStr(
          detailData.payload.tags
            .map(tag => {
              return `${tag.tagName}`;
            })
            .join(' ')
        );
        setImage(detailData.payload.image);
        setCreatedAt(detailData.payload.createdAt);
        setUpdatedAt(detailData.payload.updatedAt);
      });
    };
    const detailOpenAction = params => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      getGroupGochiMenu(params.id)
        .then(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          updateOpenDetailModal(true);
        })
        .catch(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };
    const editOpenAction = id => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      getGroupGochiMenu(id)
        .then(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          updateOpenEdit(true);
        })
        .catch(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };
    const deleteOpenAction = id => {
      updateOpenDelete(true);
      setTargetRowId(id);
    };
    const cancelAction = () => updateOpenDelete(false);
    const deleteAction = async () => {
      updateLoading(true);
      updateOpenDeleteProgress(true);
      const deletedMenu = await actions
        .deleteGroupGochiMenu(targetRowId)
        .then(data => checkSession(data));
      if (deletedMenu.type === 'DELETE_GROUP_GOCHI_MENU_SUCCESS') {
        updateIsDeleteSuccess(true);
        actions.getGroupGochiMenus(searchKey).then(data => checkSession(data));
        handleChangePage(null, 0);
        setResultMessage('削除が完了しました。');
        updateLoading(false);
      } else {
        updateIsDeleteSuccess(false);
        setResultMessage('削除に失敗しました。');
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      if (isDeleteSuccess) {
        updateOpenDelete(false);
        updateOpenDeleteProgress(false);
      } else {
        updateOpenDeleteProgress(false);
      }
    };

    return (
      <div>
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <GroupGochiMenuTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              roles={roles}
            />
            <GroupGochiMenuTableBody
              menus={groupMenus}
              emptyRows={emptyRows}
              page={page}
              rowsPerPage={rowsPerPage}
              updateOpenDetailModal={updateOpenDetailModal}
              detailOpenAction={detailOpenAction}
              editOpenAction={editOpenAction}
              deleteOpenAction={deleteOpenAction}
              setTargetRowId={setTargetRowId}
              roles={roles}
              order={order}
              orderBy={orderBy}
            />
          </Table>
        </div>
        <div>
          <ExPagination
            searchResults={groupMenus}
            rowsPerPage={rowsPerPage}
            page={page}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            totalCount={totalCount}
            offset={offset}
            selectedPage={selectedPage}
          />
        </div>
        <Modal
          open={openDetailModal}
          onClose={() => {
            updateOpenDetailModal(false);
          }}
        >
          <GroupGochiMenuDetail
            updateOpenDetailModal={updateOpenDetailModal}
            updateOpenEditModal={updateOpenEdit}
            detail={detail}
          />
        </Modal>
        <Modal open={openEdit}>
          <GroupGochiMenuEdit
            name={name}
            openEditConfirm={openEditConfirm}
            updateOpenEdit={updateOpenEdit}
            updateOpenEditConfirm={updateOpenEditConfirm}
            editInput={detail}
            searchKey={searchKey}
          />
        </Modal>
        <DeleteDialog
          openDelete={openDelete}
          updateOpenDelete={updateOpenDelete}
          cancelAction={cancelAction}
          deleteAction={deleteAction}
          targetRowId={targetRowId}
          target="グループメニュー"
        />
        <ProgressDialog
          openProgress={openDeleteProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
